import { useTranslation } from "react-i18next";
import { useLoaderData, useRouteLoaderData } from "react-router-dom";
import { useState } from "react";
import { ReturnButton } from "../../components/ReturnButton";
import { useSearch } from "../../react-helpers/array";
import {
  CandidateInvitation,
  Organization,
} from "../../services/organization/organizationModel";
import InviteCandidatesDialog from "./InviteCandidatesDialog";
import InvitedCandidatesTable from "./InvitedCandidatesTable";

const OrganizationInvitedCandidatesPage = () => {
  const { t } = useTranslation(["organization"]);
  const { organization } = useRouteLoaderData("organization") as {
    organization: Organization;
  };
  const { candidateInvitations } = useLoaderData() as {
    candidateInvitations: CandidateInvitation[];
  };

  const [searchedInvitations, setSearch] = useSearch(
    candidateInvitations,
    (candidateInvitation) => ({ email: candidateInvitation.email }),
  );

  const [isInviteDialogOpen, setInviteDialogOpen] = useState(false);

  return (
    <div className="layout_content --bg--organization-dashboard">
      <div className="page-content container --wrap">
        <ReturnButton fallbackUrl="../.." />
        <h1 className="page_title">
          {t("organization:invited-candidates.PAGE_TITLE")}
        </h1>
        <p className="lblock--l">
          {t("organization:invited-candidates.SUBTITLE")}
        </p>

        <div className="lblock--l info --success invitation">
          <div>
            <strong>
              {t("organization:candidates-profiles.INVITE_CANDIDATES")}
            </strong>
            <div>
              {t("organization:candidates-profiles.INVITE_MAIL_MESSAGE")}
            </div>
          </div>
          <div>
            <a
              className="btn --block active"
              aria-current="page"
              onClick={() => setInviteDialogOpen(true)}
            >
              {t("organization:candidates-profiles.INVITE_BUTTON")}
            </a>
          </div>
        </div>

        <div className="lblock">
          <div className="lblock--l grid-3">
            <input
              type="text"
              className="input"
              placeholder={t("organization:invited-candidates.SEARCH_EMAIL")}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>

          <InvitedCandidatesTable candidateInvitations={searchedInvitations} />
        </div>
      </div>

      {isInviteDialogOpen && (
        <InviteCandidatesDialog
          onClose={() => setInviteDialogOpen(false)}
          organization={organization}
        />
      )}
    </div>
  );
};

export default OrganizationInvitedCandidatesPage;
